import * as yup from "yup";
const uuidRegex = /^U-(\d{4}-){3}\d{4}$/;

export default yup.object({
  uuid: yup
    .string()
    .max(21, "کد عضویت معتبر وارد کنید.")
    .min(21, "کد عضویت معتبر وارد کنید.")
    .matches(uuidRegex, "لطفاکد رهگیری معتبر وارد کنید."),
});
